export default __webpack_public_path__ + "static/media/1629.1f4e2bcc.png";